import { ISymbolsHandler } from '../../getSymbolsChecks.types';

const NOT_VALID_SYMBOLS_FOR_LINK = ['\n'];

export const handlerCloseSquareBracket: ISymbolsHandler = (opts) => {
  const { text, index, symbolMatches } = opts;

  if (text[index + 1] !== '(') {
    return;
  }

  let parenthesesBalance = 0;

  for (let i = index + 2; i < text.length; i++) {
    const char = text[i];

    if (NOT_VALID_SYMBOLS_FOR_LINK.includes(char)) {
      break;
    }

    if (char === '(') {
      parenthesesBalance += 1;
      continue;
    }

    if (char === ')') {
      if (parenthesesBalance > 0) {
        parenthesesBalance -= 1;
        continue;
      }

      symbolMatches[']'].push({
        start: index,
        end: i + 1,
        link: text.substring(index + 2, i),
      });
      break;
    }
  }
};
